var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoeffects = function SvgNoeffects(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.773 12.7721C14.0389 11.5062 14.7501 9.78929 14.7501 7.99907C14.7501 6.20884 14.0389 4.49194 12.773 3.22607C11.5072 1.96019 9.79026 1.24902 8.00004 1.24902C6.20982 1.24902 4.49292 1.96019 3.22704 3.22607M12.773 12.7721C11.5072 14.0379 9.79026 14.7491 8.00004 14.7491C6.20982 14.7491 4.49292 14.0379 3.22704 12.7721C1.96116 11.5062 1.25 9.78929 1.25 7.99907C1.25 6.20884 1.96116 4.49194 3.22704 3.22607M12.773 12.7721L3.22704 3.22607",
    stroke: "#8F9294",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoeffects);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "noeffects.674f79e6d5d5fcf8a7f979a22612c17a.svg";